import { z } from "zod/v4";
import { SlideInPanelAnchorLocation } from "../slide-in-panel/slide-in-panel-anchor-location";

/**
 * Main schema for loyalty storefront popup settings
 */
const storefrontPopupSchema_ = z.object({
  enabled: z.boolean(),
  anchorPosition: z.enum(SlideInPanelAnchorLocation),
});

export const storefrontPopupSchema: z.ZodType<StorefrontPopup> =
  storefrontPopupSchema_;

export type StorefrontPopup = z.infer<typeof storefrontPopupSchema_>;
